(() => {
  const selectors = {
    productForm: '.product-recommendations__form',
    formInput: '.product-recommendations__form-input',
    cartCount: '.cart-link__bubble',
    cartPopUp: '.cart-popup',

    cartCountVisibleClass: 'cart-link__bubble--visible'
  }

  async function addToCart(event) {
    event.preventDefault();

    const currentForm = event.target;
    const currentVariantID = currentForm.querySelector(selectors.formInput).value;
    const cartPopUp = document.querySelector(selectors.cartPopUp);

    const addToCartPromise = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: currentVariantID,
          quantity: 1
        }]
      }),
    });

    if (addToCartPromise && !addToCartPromise.ok) {
      const errorObject = await addToCartPromise.json();

      throw new Error(errorObject.description);
    } else {
      const numberCounts = document.querySelectorAll(selectors.cartCount);

      numberCounts.forEach((count) => {
        count.innerText = +count.innerText + 1;
        count.classList.add(selectors.cartCountVisibleClass);
      });

      if (cartPopUp) {
        window.showCartPopup();
      };
    }
  };

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    async function fetchData() {
      try {
        const response = await fetch(url);
        const text = await response.text();
        const html = document.createElement('div');
        const lozadObserver = lozad();
        html.innerHTML = text;

        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }

        await new Promise(resolve => {
          ratingSnippet("ruk_rating_snippet", {
            store: "happyglam",
            color: "#F0544F",
            linebreak: false,
            usePolaris: true,
            callback: function () {
              var empty = document.querySelectorAll('.ruk_rating_snippet:not([data-done])');
              for (var i = 0; i < empty.length; i++) {
                if (empty[i].innerHTML == '') {
                  empty[i].innerHTML = `<i class="ruk-icon-percentage-star--100 ruk-icon-percentage-star--empty"></i><i class="ruk-icon-percentage-star--100 ruk-icon-percentage-star--empty"></i><i class="ruk-icon-percentage-star--100 ruk-icon-percentage-star--empty"></i><i class="ruk-icon-percentage-star--100 ruk-icon-percentage-star--empty"></i><i class="ruk-icon-percentage-star--100 ruk-icon-percentage-star--empty"></i><span class="ruk-rating-snippet-count">(0)</span>`;
                }
              }
              resolve();
            }
          });
        });

        const productForm = document.querySelectorAll(selectors.productForm);

        productForm.forEach((form) => {
          form.addEventListener('submit', addToCart);
        });

        await lozadObserver.observe()
      } catch (e) {
        console.error(e);
      }
    }
    fetchData();
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);
})();